import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useState } from 'react';

interface IframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  [key: string]: unknown;
}

export const Iframe = ({ ...iframeProps }: IframeProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <div className="flex justify-center items-center w-full h-full absolute top-0 left-0 z-10 bg-white/70">
          <ProgressSpinner />
        </div>
      )}

      <iframe
        {...iframeProps}
        onLoad={() => setIsLoading(false)}
        style={{ ...iframeProps.style, visibility: isLoading ? 'hidden' : 'visible' }}
      />
    </>
  );
};
